<template>
  <div class="login">
    <section class="login__brand">
      <div class="login__brand-inner">
        <span class="login__logo"><img src="@/assets/logo-jersey.jpeg" alt="Jersey"></span>
        <h1>{{title}}</h1>
        <p>Sistema de Controle Leiteiro</p>
      </div>
    </section>

    <section class="login__panel">
      <v-form class="login__card">
        <h2>Acessar o SCL</h2>
        <p class="login__hint">Entre com seu usuário e senha</p>

        <v-text-field
          outlined
          label="Usuário"
          prepend-inner-icon="mdi-account"
          v-model="user.username"
        ></v-text-field>

        <v-text-field
          outlined
          label="Senha"
          prepend-inner-icon="mdi-lock"
          v-model="user.password"
          type="password"
        ></v-text-field>

        <v-btn
          block
          large
          class="jersey-yellow"
          @click="submitLogin"
        >
          Acessar SCL
        </v-btn>

        <p class="login__support">Fale com o suporte</p>
      </v-form>
    </section>
  </div>
</template>

<script>
import {mapActions, mapState} from "vuex";
export default {
  name:"Login",
  data() {
    return {
      user:{},
      emailErrors:null
    }
  },
  computed: {
    ...mapState("login", ["title", "image"]),
  },
  methods: {
    //Mapeamentos das ações de vuex
    ...mapActions("login", ["actionSetUser"]),
    //Esse metodo emitirá a ação de login 
    async submitLogin() {
      await this.actionSetUser(this.user);
    }
  },
  mounted() {
    document.addEventListener("keypress", (e) => {
      if(e.key === "Enter") {
        this.submitLogin();
      }
    })
  }
}
</script>

<style scoped>
  .login {
    width: 100%;
    min-height: 100vh;
    display: flex;
    background: var(--backround-page);
  }
  /* painel da marca */
  .login__brand {
    flex: 1 1 52%;
    position: relative;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 48px;
    color: white;
    background: linear-gradient(145deg, #c48a00 0%, #a87600 55%, #7d5700 100%);
  }
  .login__brand::before,
  .login__brand::after {
    content: "";
    position: absolute;
    border-radius: 50%;
    background: rgba(255, 255, 255, .08);
  }
  .login__brand::before {
    width: 520px;
    height: 520px;
    top: -180px;
    right: -160px;
  }
  .login__brand::after {
    width: 360px;
    height: 360px;
    bottom: -140px;
    left: -100px;
  }
  .login__brand-inner {
    position: relative;
    z-index: 1;
    max-width: 460px;
    text-align: center;
    animation: rise .5s ease-out;
  }
  .login__logo {
    width: 180px;
    height: 180px;
    margin: 0 auto 28px;
    border-radius: 50%;
    background: white;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 0 0 10px rgba(255, 255, 255, .18), 0 18px 40px rgba(0, 0, 0, .18);
    overflow: hidden;
  }
  .login__logo img {
    width: 160px;
  }
  .login__brand h1 {
    text-wrap: balance;
    font-size: 1.9rem !important;
    font-weight: 800;
    line-height: 1.2;
    margin-bottom: 10px;
    text-shadow: 0 2px 8px rgba(0, 0, 0, .12);
  }
  .login__brand p {
    font-size: 1rem;
    letter-spacing: .04em;
    text-transform: uppercase;
    margin: 0;
  }
  /* formulário */
  .login__panel {
    flex: 1 1 48%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 48px 24px;
  }
  .login__card {
    width: 100%;
    max-width: 400px;
    padding: 40px 36px 28px;
    background: white;
    border: 1px solid var(--line);
    border-radius: 16px;
    box-shadow: var(--shadow-md);
    animation: rise .5s ease-out .05s both;
  }
  .login__card h2 {
    font-size: 1.5rem !important;
    font-weight: 800;
    color: var(--medium-blue);
    margin-bottom: 4px;
  }
  .login__hint {
    color: var(--muted);
    margin-bottom: 26px;
  }
  .login__support {
    margin: 22px 0 0;
    text-align: center;
    color: var(--muted);
    font-size: .85rem;
  }
  .jersey-yellow {
    background-color: var(--jersey-yellow) !important;
    color: white !important;
    height: 48px !important;
    font-size: 1rem;
  }
  .jersey-yellow:hover {
    background-color: var(--jersey-yellow-dark) !important;
  }
  @keyframes rise {
    from { opacity: 0; transform: translateY(12px); }
    to { opacity: 1; transform: translateY(0); }
  }
  @media (max-width: 900px) {
    .login {
      flex-direction: column;
    }
    .login__brand {
      flex: 0 0 auto;
      padding: 36px 24px;
    }
    .login__logo {
      width: 110px;
      height: 110px;
      margin-bottom: 16px;
    }
    .login__logo img {
      width: 96px;
    }
    .login__brand h1 {
      font-size: 1.3rem !important;
    }
  }
</style>
